import type { StyleRule } from '@archipro-design/aria';
import { labelClassName, pxArrayToRem, pxToRem } from '@archipro-design/aria';

export const Locations: StyleRule = ({ theme }) => ({
    flexDirection: 'column',
    alignItems: 'flex-start !important',
    padding: pxArrayToRem([16, 0, 15, 0]),
    '& > div': {
        lineHeight: '110%',
    },
    [theme.screen.laptop]: {
        padding: pxArrayToRem([24, 0, 23, 0]),
        '& > div': {
            lineHeight: '110%',
            letterSpacing: theme.siteVariables.letterSpacingMedium,
        },
    },
});

export const LocationSpinner: StyleRule = ({ theme }) => ({
    '& svg': {
        fill: theme.siteVariables.colorScheme.default!.foreground,
    },
});

export const LocationsLink: StyleRule = ({ theme }) => ({
    marginTop: pxToRem(16),
    color: theme.siteVariables.colorScheme.default!.foreground1,
    ['& .' + labelClassName]: {
        textDecoration: 'underline',
        textDecorationThickness: '1px',
        textUnderlineOffset: pxToRem(2),
    },
    [theme.screen.laptop]: {
        marginTop: pxToRem(24),
    },
});

export const Single: StyleRule = () => ({
    marginTop: pxToRem(1),
    textDecoration: 'underline',
});

export const MultipleLocations: StyleRule = ({ theme }) => ({
    marginTop: pxToRem(1),

    color: theme.siteVariables.colors.charcoal['000'],
    [`&:visited, &:active`]: {
        color: theme.siteVariables.colors.charcoal['000'],
    },
});

export const Location: StyleRule = ({ theme }) => ({
    marginTop: pxToRem(3.5),
    [theme.screen.laptop]: {
        marginTop: pxToRem(1),
    },
});

export const FindNearest: StyleRule = ({ theme }) => ({
    margin: pxArrayToRem([-1, 0, 0, -4]),
    textAlign: 'left',
    textDecoration: 'underline',
    textUnderlineOffset: pxToRem(2),
    color: theme.siteVariables.colorScheme.default!.foreground1,

    '& svg path': {
        fill: theme.siteVariables.colorScheme.default!.foreground1,
    },
    '&:hover': {
        backgroundColor: 'unset',
    },
    [`& .${labelClassName}`]: {
        marginTop: pxToRem(1),
    },
    [theme.screen.laptop]: {
        gap: pxToRem(4),
        margin: pxArrayToRem([-4, 0, 0, -4]),
        textDecoration: 'none',
    },
});
